// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_f2-3";
export var flatBottomCorners = "_f2-5";
export var productImage = "_f2-0";
export var quantityContainer = "_f2-2";
export var quantityHeader = "_f2-6";
export var tooltip = "_f2-1";
export var wrapAndEllipsesOverflow = "_f2-4";